import React, { useEffect, useState } from "react";

import Modal from "../../../components/modal";
import userIcon from "../../../assets/icons/iconeUser.png";

import "./navbar.scss";
import { useTypedSelector } from "../../../redux/useTypedSelector";
import AuthService from "../../../services/AuthService";

interface IndexInterface {
  user: any,
  handleLogout: any,
  handleSelect: any,
  error?: boolean
};

const Index: React.FC<IndexInterface> = ({ user, handleLogout, handleSelect, error }) => {
  const [menuActive, setMenuState] = useState(false);
  const [usuario, setUsuario] = useState({ nome: "" });
  const [lastAccess, setLastAccess] = useState("");
  // const dispatch = useDispatch();
  const { title, help_text } = useTypedSelector((state) => state);
  useEffect(() => {
    var _user = AuthService.get_user_storage();
    var _lastAccess = localStorage.getItem("lastAccess");

    if (_user) setUsuario(_user);
    setLastAccess(_lastAccess ? JSON.parse(_lastAccess) : "");
  }, []);

  return (
    <>
      <div className="navbar-container">
        <div className="navbar-item-container">
          <h1>{title ? title : ""}</h1>
          {help_text && <Modal title={"Ajuda"} />}
        </div>
        <div className="navbar-item-container">
          <div className="user-head-container">
            <div className="user-head-content">
              <img src={userIcon} alt="User" />
              {<p>{usuario.nome}</p>}
            </div>
            <div className="user-head-access">
              {<p>Acessado em: {lastAccess}</p>}
              {error && error}
            </div>
          </div>
          <button className="global-btn" onClick={() => handleLogout()}>
            Voltar
          </button>
        </div>
      </div>
      {/* <h5>Bem vindo, {user && user.name}</h5> */}
    </>
  );
}

export default Index